import { stage_url, sub_urls } from "../api-urls";
import axios from "axios";
import Headers from "./Headers";

/*
 * V3 Scheme + Calc module — see backend handoff doc for full contract.
 * Base path: {stage_url}v3/...
 * Response envelope everywhere: { data: <payload>, message: "..." }
 * Errors: non-200 with { message, status } — surface `message` verbatim.
 */
export const SchemesV3Api = {
  GetByFilter: async (payload) => {
    const response = await axios.get(stage_url + sub_urls.schemesV3.filter, {
      params: {
        brandId: payload.brandId,
        periodFrom: payload.periodFrom,
        periodTo: payload.periodTo,
        status: payload.status || undefined,
        productId: payload.productId || undefined,
        keyword: payload.keyword || undefined,
        page: payload.page,
        size: payload.size,
      },
      headers: Headers.getHeaders(),
    });
    return response;
  },

  GetById: async (id) => {
    const response = await axios.get(stage_url + sub_urls.schemesV3.baseUrl + "/" + id, {
      headers: Headers.getHeaders(),
    });
    return response;
  },

  Create: async (payload) => {
    const response = await axios.post(stage_url + sub_urls.schemesV3.baseUrl, payload, {
      headers: Headers.getHeaders(),
    });
    return response;
  },

  // Full-document replace — only valid while DRAFT / IN_REVIEW.
  Update: async (id, payload) => {
    const response = await axios.put(stage_url + sub_urls.schemesV3.baseUrl + "/" + id, payload, {
      headers: Headers.getHeaders(),
    });
    return response;
  },

  // Edit an ACTIVE scheme — re-runs full publish validation, publishVersion +1.
  Amend: async (id, payload) => {
    const response = await axios.put(
      stage_url + sub_urls.schemesV3.baseUrl + "/" + id + "/amend",
      payload,
      { headers: Headers.getHeaders() }
    );
    return response;
  },

  Submit: async (id) => {
    const response = await axios.post(
      stage_url + sub_urls.schemesV3.baseUrl + "/" + id + "/submit",
      null,
      { headers: Headers.getHeaders() }
    );
    return response;
  },

  Publish: async (id) => {
    const response = await axios.post(
      stage_url + sub_urls.schemesV3.baseUrl + "/" + id + "/publish",
      null,
      { headers: Headers.getHeaders() }
    );
    return response;
  },

  Archive: async (id) => {
    const response = await axios.post(
      stage_url + sub_urls.schemesV3.baseUrl + "/" + id + "/archive",
      null,
      { headers: Headers.getHeaders() }
    );
    return response;
  },
};

export const TargetGroupTemplatesV3Api = {
  GetByFilter: async (brandId) => {
    const response = await axios.get(stage_url + sub_urls.targetGroupTemplatesV3.filter, {
      params: { brandId },
      headers: Headers.getHeaders(),
    });
    return response;
  },

  GetById: async (id) => {
    const response = await axios.get(
      stage_url + sub_urls.targetGroupTemplatesV3.baseUrl + "/" + id,
      { headers: Headers.getHeaders() }
    );
    return response;
  },

  Create: async (payload) => {
    const response = await axios.post(
      stage_url + sub_urls.targetGroupTemplatesV3.baseUrl,
      payload,
      { headers: Headers.getHeaders() }
    );
    return response;
  },

  Update: async (id, payload) => {
    const response = await axios.put(
      stage_url + sub_urls.targetGroupTemplatesV3.baseUrl + "/" + id,
      payload,
      { headers: Headers.getHeaders() }
    );
    return response;
  },

  Archive: async (id) => {
    const response = await axios.post(
      stage_url + sub_urls.targetGroupTemplatesV3.baseUrl + "/" + id + "/archive",
      null,
      { headers: Headers.getHeaders() }
    );
    return response;
  },
};

export const EarningV3Api = {
  // Calculates the logged-in user's earnings for one ACTIVE scheme.
  // declaredTarget is required only for *_TARGET_FROM_RETAILER configs.
  Calculate: async (schemeId, declaredTarget) => {
    const response = await axios.get(stage_url + sub_urls.earningV3.calculate, {
      params: {
        schemeId,
        declaredTarget: declaredTarget !== undefined && declaredTarget !== "" ? declaredTarget : undefined,
      },
      headers: Headers.getHeaders(),
    });
    return response;
  },
};
